import { ensureString } from 'ensure-string';

export function parseRes(res) {
  res = ensureString(res);

  let meta = {};
  let currentMeta;
  for (let line of res.split(/\r?\n/).filter(Boolean)) {
    if (line.startsWith('[')) {
      currentMeta = {};
      meta[line.replace(/\[(.*)\]/, '$1')] = currentMeta;
    } else {
      const { field, value } = line.match(/(?<field>.*?)=(?<value>.*)/).groups;

      currentMeta[field] = Number.isNaN(Number(value))
        ? value
        : Number.parseFloat(value);
    }
  }
  return meta;
}
